import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTitleHeld = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={12}
    fill="none"
    viewBox="0 0 14 12"
    {...props}
  >
    <path
      fill="#999"
      d="M5.056 1.333v.254a4.7 4.7 0 0 0-1.74-.334c-.946 0-1.893.287-2.7.86a.67.67 0 0 0-.086 1.02l1.713 1.713h.74v.74c.573.574 1.32.874 2.073.907V8H3.723c-.367 0-.667.3-.667.666V10c0 .733.6 1.333 1.334 1.333h6.666c1.107 0 2-.893 2-2v-8c0-.366-.3-.666-.666-.666H5.723c-.367 0-.667.3-.667.666m-.74 3.607V3.506h-1.52l-.693-.693a3.4 3.4 0 0 1 1.213-.227c.894 0 1.727.347 2.36.974l.94.94-.133.133a1.8 1.8 0 0 1-1.28.534c-.313 0-.62-.08-.887-.227m7.407 4.393c0 .367-.3.667-.667.667a.67.67 0 0 1-.666-.667v-.667c0-.366-.3-.666-.667-.666H6.39V6.273c.38-.153.733-.38 1.04-.686l.133-.134 1.887 1.88h.94v-.94l-4-3.98V2h5.333z"
    />
  </svg>
);
export default SvgTitleHeld;
